import get from 'lodash.get';

const getOwnerId = (rootState) => get(rootState, 'ws.site.ownerId');

export default getOwnerId;
